'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import ClientOnly from '@/components/ClientOnly';
import { useAuth as useAuthCore } from '@/contexts/AuthContext';
import type { User } from 'firebase/auth';

// --- Type Definition for Auth Context Value ---
// Define the expected shape based on AuthContext.jsx
// We define it here as a workaround for TS inference issues with the JS context file
interface AuthContextValue {
  user: User | null;
  loading: boolean;
  signIn: ((email: string, pass: string) => Promise<any>) | null;
  signUp: ((email: string, pass: string) => Promise<any>) | null;
  signInWithGoogle: (() => Promise<any>) | null;
  logOut: (() => Promise<any>) | null;
}

// Create a typed wrapper around the original hook
const useAuth = (): AuthContextValue => useAuthCore() as AuthContextValue;
// --- End Type Definition ---

// Dynamic import for the search modal to prevent SSR
const SearchModal = dynamic(() => import('./SearchModal'), { ssr: false });
// Dynamic import for the auth modal
const AuthModal = dynamic(() => import('./AuthModal'), { ssr: false });

interface SearchBarProps {
  // Any future props can be added here
}

const SearchBar: React.FC<SearchBarProps> = () => {
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { user, logOut } = useAuth();

  const handleOpenSearchModal = () => {
    setShowSearchModal(true);
  };

  const handleCloseSearchModal = () => {
    setShowSearchModal(false);
  };

  const handleOpenAuthModal = () => {
    setShowAuthModal(true);
  };

  const handleCloseAuthModal = () => {
    setShowAuthModal(false);
  };

  return (
    <div className="nav-item nav-icon row">
      <div className="col-4">
        <button
          onClick={handleOpenSearchModal}
          className="nav-link search-trigger-btn w-100"
          aria-label="Search"
        >
          <i className="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>

      {/* <div className="col-8">
        {!user ? (
          <button
            onClick={handleOpenAuthModal}
            className="nav-link auth-trigger-btn w-100"
            aria-label="Login or Sign Up"
          >
            <i className="fa fa-user-plus" aria-hidden="true"></i>&nbsp;
            Sign Up
          </button>
        ) : (
          <button
            onClick={() => { if (logOut) { logOut(); } }}
            className="nav-link auth-trigger-btn w-100"
            aria-label="Logout"
          >
            <i className="fa fa-sign-out" aria-hidden="true"></i>
            Logout
          </button>
        )}
      </div> */}

      <ClientOnly>
        {showSearchModal && <SearchModal show={showSearchModal} onHide={handleCloseSearchModal} />}
      </ClientOnly>

      {/* <ClientOnly>
        {showAuthModal && <AuthModal show={showAuthModal} onHide={handleCloseAuthModal} />}
      </ClientOnly> */}
    </div>
  );
};

export default SearchBar;
